var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { call, put, takeLatest } from "redux-saga/effects";
import { GET_MESSAGE_COUNT_REQUEST, getMessageCountFailure, getMessageCountSuccess } from "../../actions";
import API from "../../../utils/API";
const onGetMessageCount = (action) => __awaiter(void 0, void 0, void 0, function* () {
    return yield new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            API.get(`/notification/wa/trial/status`)
                .then((data) => {
                resolve(data);
            })
                .catch((error) => {
                reject(error);
            });
        }
        catch (error) {
            if (error instanceof Error) {
                reject(error);
            }
        }
    }));
});
function* getMessageCountWorker(action) {
    try {
        const data = yield call(onGetMessageCount, action);
        yield put(getMessageCountSuccess(data));
    }
    catch (error) {
        yield put(getMessageCountFailure(error));
    }
}
export function* watchGetMessageCountData() {
    yield takeLatest(GET_MESSAGE_COUNT_REQUEST, getMessageCountWorker);
}
